<template>
  <div class="flex-auto flex-row px-4 py-5 sm:px-6 bg-white border border-gray-200 rounded-md">
    <div v-if="!hideBackButton" class="flex justify-between items-center">
      <button ref="toggleButton" @click="toggle" type="button" class="text-gray-500 group bg-white rounded-md inline-flex items-center text-base font-medium hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500" aria-expanded="false">

      <svg class="mr-2 mt-1 h-5 w-5" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 511.999 511.999" style="enable-background:new 0 0 511.999 511.999;" xml:space="preserve">
        <path style="fill:#E21B1B;" d="M103.919,51.744c0,0,41.296,33.496,109.008,18.4c64.2-14.264,124.056-30.464,224.616,5.856v215.032c0,0-92.488-44.104-176.736-24.432s-131.88,12.12-156.888-12.888"/>
        <rect x="90.74" y="37.524" style="fill:#999999;" width="16" height="474.475"/>
        <circle style="fill:#666666;" cx="98.741" cy="24.284" r="24.284"/>
        <g>
        </g>
        <g>
        </g>
        <g>
        </g>
        <g>
        </g>
        <g>
        </g>
        <g>
        </g>
        <g>
        </g>
        <g>
        </g>
        <g>
        </g>
        <g>
        </g>
        <g>
        </g>
        <g>
        </g>
        <g>
        </g>
        <g>
        </g>
      </svg>

      <span>{{ $t('issues.plural_issue_label') }}</span>

      <svg v-if="!noIssues" class="text-gray-400 ml-2 h-5 w-5 group-hover:text-gray-500" :class="displayIssues ? '' : '-rotate-90'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
        <path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd" />
      </svg>
      </button>
      <div v-show="!displayIssues" class="flex items-center">{{ numIssuesLabel }}</div>
      <button v-show="!creatingIssue" @click="createIssue()" class="flex-shrink-0 flex items-center btn btn-secondary"> {{ $t('issues.create_issue_label') }} </button>
    </div>

    <div v-if="displayIssues" class="overflow-hidden">
      <div v-if="showingIssue">
        <button v-if="!hideBackButton" @click="issueIndex()" type="button" class="p-1 border-2 mt-2 text-gray-500 group rounded-md inline-flex items-center text-base font-medium hover:text-gray-900 hover:bg-gray-100" aria-expanded="false">
          <span>Back</span>
        </button>

        <issue @delete-issue="handleIssueDeletion($event)" @aasm-state-change="handleStateChange($event)" @issue-activity-item-creation="handleIssueActivityItemCreation($event)" :data="showIssueData" :userName="data.current_user_name" :isAdmin="data.is_super_admin" :userId="data.current_user_id" :hideName="hideBackButton" :avatarURL="data.avatarURL"> </issue>
      </div>
      
      <div v-else-if="creatingIssue">
        <button @click="issueIndex()" type="button" class="p-1 border-2 mt-2 text-gray-500 group rounded-md inline-flex items-center text-base font-medium hover:text-gray-900 hover:bg-gray-100" aria-expanded="false">
          <span>Back</span>
        </button>

        <new-issue @new-issue="handleNewIssueCreation($event)" :data="data"> </new-issue>
      </div>

      <div v-else>
        <div class="p-4 flex justify-center" v-if="noIssues">
          {{ $t('issues.no_issues_label') }}
        </div>

        <ul role="list" class="divide-y divide-gray-200">
          <li v-for="issue in issues" :key="issue.id">
            <div @click="openIssue(issue)">
              <issue-line-item :issueData="issue"> </issue-line-item>
            </div>
          </li>
        </ul>

        <div class="border-solid border-t flex justify-center">
          <button v-if="!noMoreIssues" @click="createIssue()" class="m-4 btn btn-secondary"> {{ $t('issues.create_issue_label') }} </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import SerializedResponse from '@services/SerializedResponse'

  import IssueLineItem from '@components/issues/IssueLineItem'
  import Issue from '@components/issues/Issue'
  import NewIssue from '@components/issues/NewIssue'
  import IssueModel from '@models/Issue'
  export default {
    name: '',
    components: {
      IssueLineItem,
      Issue,
      NewIssue,
    },
    data () {
      return {
        showingIssue: false,
        creatingIssue: false,
        showIssueData: null,
        issues: null,
        displayIssues: this.data.from_issue,
        hideBackButton: false,
      }
    },
    created () {
      if (this.data.relatable_type == 'FormResponse') {
        this.requestIssueData(this.data.relatable_id)
      }

      if (this.data.from_issue) {
        setTimeout(() => {
          this.openIssue({})
        }, 800);
      }
    },
    computed: {
      noIssues () {
        return this.issues ? this.issues.length == 0 : false
      },
      noMoreIssues () {
        return this.issues && this.issues.length >= 1
      },
      numIssuesLabel () {
        let rval = ''
        if (this.issues && this.issues.length > 0) {
          console.log("issues.length = ", this.issues.length)
          if (this.issues.length == 1) {
            rval = '1 ' + this.$i18n.t('issues.singular_issue_label')
          } else if (this.issues.length > 1) {
            rval = this.issues.length + ' ' + this.$i18n.t('issues.plural_issue_label')
          }
        } else {
          console.log("no issues")
          rval = this.$i18n.t('issues.no_issues_label')
        }
        console.log("rval = ", rval) 
        return rval
      },
    },
    methods: {
      requestIssueData (relatable_id) {
        return axios.get(`/forms/responses/${relatable_id}/gather_issues.json`)
          .then(resp => {
            console.log("requestIssueData", resp)
            this.issues = (new SerializedResponse(IssueModel, resp.data)).modelData
          })

      },
      toggle () {
        if (!this.noIssues) {
          this.displayIssues = !this.displayIssues
        }
        this.$refs.toggleButton.blur()
      },
      openIssue (issue) {
        if (this.data.from_issue) {
          issue = this.issues && this.issues.find(issue => issue.id == this.data.issue_id)
          this.hideBackButton = true
        }

        this.showingIssue = true
        this.showIssueData = issue
      },
      issueIndex () {
        this.showingIssue =  false
        this.creatingIssue = false
        if (this.noIssues) {
          this.displayIssues = false
        }
      },
      createIssue () {
        this.displayIssues = true
        this.creatingIssue = true
      },
      handleStateChange () {
        setTimeout(() => {
          this.requestIssueData(this.data.relatable_id)
        }, 1000)
      },
      handleNewIssueCreation () {
        setTimeout(() => {
          this.requestIssueData(this.data.relatable_id)
          this.creatingIssue = false
          this.showingIssue = false
        }, 1000)
      },
      handleIssueDeletion () {
        setTimeout(() => {
          this.requestIssueData(this.data.relatable_id)
          this.creatingIssue = false
          this.showingIssue = false
        }, 1000)
      },
      handleIssueActivityItemCreation (event) {
        this.requestIssueData(this.data.relatable_id).then(() => {
          this.showIssueData = this.issues.find((i) => i.id == event.issueActivityItem.issue_id)
        })
      },
    },
    props: {
      data: {
        type: Object,
        required: false,
      }
    },
  }
</script>

<style lang="scss">
</style>
